import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PreviewModal = ({ template, onClose, onSelect }) => {
  const [currentViewport, setCurrentViewport] = useState('desktop');
  const [currentScreenshot, setCurrentScreenshot] = useState(0);

  const viewportOptions = [
    { id: 'desktop', label: 'Десктоп', icon: 'Monitor' },
    { id: 'tablet', label: 'Планшет', icon: 'Tablet' },
    { id: 'mobile', label: 'Мобильный', icon: 'Smartphone' }
  ];

  const getViewportClass = () => {
    switch (currentViewport) {
      case 'mobile':
        return 'max-w-[375px]';
      case 'tablet':
        return 'max-w-[768px]';
      default:
        return 'max-w-full';
    }
  };

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4 bg-background/95 animate-in fade-in duration-200">
      <div className="bg-card rounded-2xl shadow-elevation-5 w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border">
          <div className="flex-1 min-w-0">
            <h2 className="text-xl md:text-2xl font-semibold text-foreground mb-1 truncate">
              {template?.name}
            </h2>
            <p className="caption text-text-secondary flex items-center gap-2">
              <Icon name="Tag" size={14} />
              {template?.category}
            </p>
          </div>
          <Button
            variant="ghost"
            size="icon"
            iconName="X"
            onClick={onClose}
          />
        </div>

        <div className="flex-1 overflow-y-auto p-4 md:p-6">
          <div className="flex flex-wrap items-center justify-center gap-2 mb-6">
            {viewportOptions?.map((viewport) => (
              <Button
                key={viewport?.id}
                variant={currentViewport === viewport?.id ? 'default' : 'outline'}
                size="sm"
                iconName={viewport?.icon}
                iconPosition="left"
                onClick={() => setCurrentViewport(viewport?.id)}
              >
                {viewport?.label}
              </Button>
            ))}
          </div>

          <div className="flex justify-center mb-6">
            <div className={`${getViewportClass()} transition-all duration-300 w-full`}>
              <div className="bg-muted rounded-lg overflow-hidden border border-border">
                <Image
                  src={template?.screenshots?.[currentScreenshot]}
                  alt={template?.screenshotAlts?.[currentScreenshot]}
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>

          {template?.screenshots?.length > 1 && (
            <div className="flex items-center justify-center gap-2 mb-6">
              {template?.screenshots?.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentScreenshot(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-200 ${
                    currentScreenshot === index
                      ? 'bg-primary w-8' :'bg-muted hover:bg-border'
                  }`}
                  aria-label={`Скриншот ${index + 1}`}
                />
              ))}
            </div>
          )}

          <div className="bg-muted rounded-xl p-4 md:p-6 mb-6">
            <h3 className="font-semibold text-base md:text-lg text-foreground mb-3">
              Особенности шаблона
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              {template?.features?.map((feature, index) => (
                <div key={index} className="flex items-start gap-2">
                  <Icon name="Check" size={18} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                  <span className="text-sm text-text-secondary">{feature}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-accent/10 border border-accent/20 rounded-xl p-4 md:p-6">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="font-medium text-foreground mb-1">О шаблоне</h4>
                <p className="text-sm text-text-secondary">{template?.description}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 p-4 md:p-6 border-t border-border">
          <Button
            variant="outline"
            fullWidth
            iconName="X"
            iconPosition="left"
            onClick={onClose}
          >
            Отмена
          </Button>
          <Button
            variant="default"
            fullWidth
            iconName="Check"
            iconPosition="left"
            onClick={() => onSelect(template)}
          >
            Выбрать этот шаблон
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PreviewModal;